<template>
  <QDrawer v-if="$q.screen.gt.xs" v-model="menuOpened" show-if-above :width="225" :breakpoint="599" bordered no-swipe-close content-class="bg-grey-3">
    <QList>
      <QItem clickable :to="{ name: upcomingRoute }" active-class="bg-primary text-white">
        <QItemSection avatar>
          <QIcon name="icon-f-credit-card" />
        </QItemSection>
        <QItemSection>
          {{ $t("ETAB.PAGES.DEMAND_DASHBOARD.@UPCOMING") }}
        </QItemSection>
      </QItem>
      <QItem clickable :to="{ name: inProgressRoute }" active-class="bg-primary text-white">
        <QItemSection avatar>
          <QIcon name="icon-f-server" />
        </QItemSection>
        <QItemSection>
          {{ $t("ETAB.PAGES.DEMAND_DASHBOARD.@IN_PROGRESS") }}
        </QItemSection>
      </QItem>
      <QItem clickable :to="{ name: planningRoute }" active-class="bg-primary text-white">
        <QItemSection avatar>
          <QIcon name="icon-f-calendar" />
        </QItemSection>
        <QItemSection>
          {{ $t("ETAB.PAGES.DEMAND_DASHBOARD.@PLANNING") }}
        </QItemSection>
      </QItem>
      <QItem clickable :to="{ name: surveyRoute }" active-class="bg-primary text-white">
        <QItemSection avatar>
          <QIcon name="icon-f-clock" />
        </QItemSection>
        <QItemSection>
          {{ $t("ETAB.PAGES.DEMAND_DASHBOARD.@SURVEY") }}
          <QBadge v-show="surveyTodo" color="red" floating class="dashboard-drawer-survey-badge">
            {{ $t("ETAB.PAGES.DEMAND_DASHBOARD.@SURVEY_WAITING") }}
          </QBadge>
        </QItemSection>
      </QItem>
    </QList>
  </QDrawer>
</template>

<script>
  import { ETAB_ROUTES } from "@etab/config";
  import { GETTER_SURVEY_GET_AMOUNT, ACTION_SURVEY_GET_AMOUNT } from "@etab/stores/types";
  import { useSurveyStore } from "@etab/stores/survey";
  import { mapStores } from "pinia";

  export default {
    data() {
      return {
        menuOpened: true,
      };
    },
    computed: {
      ...mapStores(useSurveyStore),
      surveyTodo() {
        return this.surveyStore[GETTER_SURVEY_GET_AMOUNT].hasTodo();
      },
    },
    created() {
      this.upcomingRoute = ETAB_ROUTES.dashboard.tabs.upcoming.name;
      this.inProgressRoute = ETAB_ROUTES.dashboard.tabs.inProgress.name;
      this.planningRoute = ETAB_ROUTES.dashboard.planning.root.name;
      this.surveyRoute = ETAB_ROUTES.survey.name;

      this.getSurveysAmount();
    },
    methods: {
      async getSurveysAmount() {
        try {
          await this.surveyStore[ACTION_SURVEY_GET_AMOUNT]();
        } catch (error) {
          // RG: fail silently, it's not so important
        }
      },
    },
  };
</script>

<style lang="scss">
  .dashboard-drawer-survey-badge {
    top: initial;
    bottom: -6px;
    right: 5px;
  }
</style>
